import React, { useEffect } from 'react';
import { RemoteMountedComponent } from '@classapp/sebastiao-orchestrator';
import PubSub from 'pubsub-js';

import { createUrlWithHash } from '../../../../utils';
import { Loading } from '@classapp-tech/edna';

import config from '../../../../../../config/server.config';

/**
 * @param {{
 *  env: 'local' | 'development' | 'stage' | 'internal' | 'production',
 *  onOpenRecipientModal: () => void,
 *  hasAttachments: boolean,
 *  recipients: any,
 *  openPersonalizedMediaModal: boolean,
 *  closePersonalizedMediaModal: () => void
 *  organizationId: string,
 *  entityId: string,
 *  accessToken: string,
 *  onSubmitFilesModal: (folderName: string) => void
 * }}
 */
export function PersonalizedFile({
  env = 'local',
  onOpenRecipientModal,
  hasAttachments,
  recipients,
  closePersonalizedMediaModal,
  organizationId,
  openPersonalizedMediaModal = false,
  entityId,
  accessToken,
  onSubmitFilesModal,
}) {
  useEffect(() => {
    const token = PubSub.subscribeOnce('MICROFRONTEND_READY', (_, mcfName) => {
      PubSub.publish(`${mcfName}_MICROFRONTEND_DATA`, {
        hasAttachments,
        onOpenRecipientModal,
        onSubmitFilesModal,
      });
    });

    return () => {
      PubSub.unsubscribe(token);
    };
  }, []);

  useEffect(() => {
    PubSub.publish('SULLY_MICROFRONTEND_DATA', {
      hasAttachments,
      onOpenRecipientModal,
      recipients,
      openPersonalizedMediaModal,
      closePersonalizedMediaModal,
      organizationId,
      entityId,
      accessToken,
      onSubmitFilesModal,
    });
  }, [
    hasAttachments,
    recipients,
    openPersonalizedMediaModal,
    organizationId,
    onSubmitFilesModal,
  ]);

  useEffect(() => {
    const token = PubSub.subscribe(
      'ON_SUBMIT_FILES_MODAL',
      (
        _,
        /** @type {{ folderName?: string, totalFilesSize?: number, totalFileQuantity?: number }} */
        data,
      ) => {
        onSubmitFilesModal({
          folderName: data?.folderName,
          totalFilesSize: data?.totalFilesSize,
          totalFileQuantity: data?.totalFileQuantity,
        });
      },
    );

    return () => {
      PubSub.unsubscribe(token);
    };
  }, []);

  return (
    <RemoteMountedComponent
      url={createUrlWithHash(
        `${config.microfrontends.sully[env]}/remoteEntry.js`,
      )}
      name="sully"
      noStyle
      moduleName="./PersonalizedFile"
      fallbackComponent={null}
      loadingComponent={<Loading variation="basic" size={20} />}
    />
  );
}
